import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fab)

const Footer = () => (
  <>
    <style jsx>{`
      .footerStyle {
        border-top: 1px #f1f1f1 solid;
        margin-top: 2rem;
        padding: 2rem 1.2rem;
      }
      .footerSocialLinks {
        margin-left: 0;
        text-align: center;
      }
      .footerSocialLinks li {
        display: inline-block;
        list-style-type: none;
      }
      .footerSocialLinks li:not(:last-of-type) {
        margin-right: 1rem;
      }
      .footerSocialLinks li a,
      .footerSocialLinks li a:hover,
      .footerSocialLinks li a:click, 
      .footerSocialLinks li a:visited {
        border:none;
        box-shadow: none;
        outline:none;
        text-decoration:none;
        color:inherit;
      }
      .footerSocialLinks li svg {
        color: #888;
        font-size: 2rem;
        border:none;
        outline:none;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
      } 
    `}</style>

    <footer className="footerStyle">
      <div className="layoutInner">
        <ul className="footerSocialLinks">
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://github.com/JGallardo/jgallardo"
              style={{ boxShadow: `none` }}
            >
              <FontAwesomeIcon icon={["fab", "github"]} />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/jgallardo2600/"
              style={{ boxShadow: `none` }}
            >
              <FontAwesomeIcon icon={["fab", "linkedin"]} />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://dribbble.com/jgallardo"
              style={{ boxShadow: `none` }}
            >
              <FontAwesomeIcon icon={["fab", "dribbble"]} />
            </a>
          </li>
        </ul>
      </div>
    </footer>
  </>
)

export default Footer